export const subscriptionQueryKeys = {
  all: ['subscription'] as const,
  full: () => ['subscription', 'full'] as const,
  invoices: () => ['subscription', 'invoices'] as const,
  billingDetails: () => ['subscription', 'billing-details'] as const,
  paymentMethod: () => ['subscription', 'payment-method'] as const,
  switchToAnnualPreview: () => ['subscription', 'switch-to-annual-preview'] as const,
};
